import { ConditionalLink } from '../ConditionalLink/ConditionalLink'
import { Badge, ClickArea, WrapIcon } from './IconButton.styles'
import type { IconButtonProps } from './IconButton.types'

export const IconButton = ({
  children,
  link,
  className,
  badge,
  onClick,
  iconSize = '2rem',
  clickAreaSize = '4.8rem',
  buttonType,
  variant = 'primary',
  color,
}: IconButtonProps): JSX.Element => {
  return (
    <ConditionalLink condition={Boolean(link)} href={link}>
      <ClickArea clickAreaSize={clickAreaSize} onClick={onClick}>
        <WrapIcon
          className={className}
          color={color}
          iconSize={iconSize}
          variant={variant}
          $buttonType={buttonType}
        >
          {children}
        </WrapIcon>
        {Boolean(badge) && <Badge>{badge}</Badge>}
      </ClickArea>
    </ConditionalLink>
  )
}
